import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';

export function useIsMobileScreen(): boolean {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return isSmallScreen;
}
